'use client';

import { useTranslations } from 'next-intl';
import { useTheme } from '@/components/theme/ThemeProvider';
import { NavigationModal } from '@/components/NavigationModal';
import { AdminSheet } from './AdminSheet';

export function AppHeader() {
  const t = useTranslations('public');
  const { theme, setTheme, mounted } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <header
      className="flex justify-between items-center flex-shrink-0"
      style={{ padding: '14px 20px 14px' }}
    >
      {/* Brand */}
      <div
        style={{
          fontFamily: 'var(--font-pub-display)',
          fontSize: 15,
          fontWeight: 800,
          letterSpacing: '-0.01em',
          background: 'var(--pub-brand-gradient)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        {t('brand')}<span style={{ WebkitTextFillColor: 'var(--pub-green)', color: 'var(--pub-green)' }}>.</span>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2">
        {/* Admin tools (only visible to admins) */}
        <AdminSheet />
        {/* Theme toggle */}
        {mounted && (
          <IconButton
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15">
                <circle cx="12" cy="12" r="5" />
                <line x1="12" y1="1" x2="12" y2="3" />
                <line x1="12" y1="21" x2="12" y2="23" />
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                <line x1="1" y1="12" x2="3" y2="12" />
                <line x1="21" y1="12" x2="23" y2="12" />
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="15" height="15">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            )}
          </IconButton>
        )}

        {/* Menu toggle — reuses existing NavigationModal (Sheet-based) */}
        <NavigationModal />
      </div>
    </header>
  );
}

function IconButton({ children, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement> & { children: React.ReactNode }) {
  return (
    <button
      className="flex items-center justify-center cursor-pointer transition-colors duration-200"
      style={{
        width: 34,
        height: 34,
        borderRadius: 10,
        border: '1px solid var(--pub-border)',
        background: 'var(--pub-surface-2)',
        color: 'var(--pub-text-secondary)',
      }}
      {...props}
    >
      {children}
    </button>
  );
}
